export class Photo {
  id: number = 0;
  src?: string;
  caption?: string;
  tags?: string[];
  albumId?: number;

  totalLike?: number;
  totalView?: number;
  total_shared?: number;

  serviceId?: number;
  serviceName?: string;

  beauticianId?: number;
  beauticianName?: string;

  constructor(fields) {
    Object.assign(this, fields);
  }
}


export function createPhoto(blob: any): Photo {
  return new Photo({
    id: blob.number,
    src: blob.src,
    caption: blob.caption,
    tags: blob.tags ? blob.tags.split(',') : [],
    albumId: blob.album_id,

    totalLike: blob.total_like,
    totalView: blob.total_view_count,
    total_shared: blob.total_shared,

    serviceId: blob.service_id,
    serviceName: blob.service_name,

    beauticianId: blob.beautician_id,
    beauticianName: blob.beautician_name,
  });
}
